import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid, SxProps, Typography} from '@mui/material';

import {bodyPdf, pdfH1, pdfH3} from './styles';
import {PdfPageBreakWrapper} from './WrapperComponents/PdfPageBreakWrapper';
import {CultureAnalysisPdfContext} from '../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';
import {orangeColors, empionOrangeGradient} from '../../../layouts/theme/designSystem';

export const EmployeeFeedback = () => {
  const {t} = useTranslation('pdfDomain');
  const {data, loading} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return null;
  }

  const employeeFeedback = data.employeeFeedback;
  const sortedFeedback = employeeFeedback?.slice().sort((a, b) => a.length - b.length);
  const hasFeedback = Boolean(sortedFeedback?.length);

  const paperStyles: SxProps = {
    padding: '8px 16px',
    backgroundColor: orangeColors[5],
    boxShadow: 'none',
    borderRadius: '0px 16px 0px 16px',
    width: '100%',
    marginTop: 2,
  };

  return (
    <>
      <Grid container p={4} sx={{background: empionOrangeGradient.dark}} height={'320px'}>
        <Typography variant='h1' sx={pdfH1}>
          {t('employeeFeedback.title')}
        </Typography>
        <Typography sx={bodyPdf}>{t('employeeFeedback.textBlock')}</Typography>
      </Grid>

      <Grid container direction='column' px={5} mt={5}>
        <Grid item>
          <Typography variant='h3' sx={pdfH3}>
            {t('employeeFeedback.feedback')}
          </Typography>
        </Grid>

        <Grid container direction='row' justifyContent='flex-start' alignItems='flex-start'>
          {hasFeedback ? (
            sortedFeedback?.map((feedback, index) => (
              <PdfPageBreakWrapper key={`${index} ${feedback}`} item xs={12}>
                <Box sx={paperStyles}>
                  <Typography
                    sx={{
                      ...bodyPdf,
                    }}
                  >
                    {feedback}
                  </Typography>
                </Box>
              </PdfPageBreakWrapper>
            ))
          ) : (
            <Grid item xs={12}>
              <Box
                sx={{
                  ...paperStyles,
                  border: `1px solid ${orangeColors[3]}`,
                  padding: '24px',
                  textAlign: 'center',
                }}
              >
                <Typography sx={bodyPdf}>{t('employeeFeedback.emptyState')}</Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
};
